import React, { useEffect, useState, useRef } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { observer } from 'mobx-react';
import { AuthAliAwsc } from '@ywfe/authmodules';
import Toast from '../../../component/toast';
import API from '../../../server/index';
import YInput from './YInput';
import './style/modal.less';

interface ModalProps {
  visible: boolean;
  close: (isLogin?: boolean) => void;
}

interface GraphCodeParams {
  graphCode?: string;
  clewNo?: string;
}

interface FormValParams {
  mobile?: string;
  graphCode?: string;
  smsCode?: string;
}

interface LoadingParams {
  getGraphCode?: boolean;
  setSms?: boolean;
  login?: boolean;
}

const Modal = observer((props: ModalProps) => {
  const { visible, close } = props;
  const timer = useRef<any>();
  const loadingRef = useRef<LoadingParams>({});
  const [formVal, setFormVal] = useState<FormValParams>({});
  const [smsCountdown, setSmsCountdown] = useState<number>(0);
  const [sliderKey, setSliderKey] = useState<number>(0);
  const fetchRef = useRef<any>({});

  //
  const checkFn = (checkMore = false) => {
    const { mobile = '', smsCode = '' } = formVal;
    if (!mobile?.trim()?.length ) {
      Toast('请输入手机号以及图形校验码');
      return true;
    }
    if (checkMore && !smsCode?.trim()?.length) {
      Toast('请输入短信校验码');
      return true;
    }
    return false;
  }

  // 表单内容修改
  const setForm = (name: string, val: string) => {
    const params = Object.assign({}, formVal, {[name]: val})
    setFormVal(params)
    fetchRef.current.forms = params;
  }
  const resetSlider = () => {
    setSliderKey((key) => key + 1);
  }
  const getSmsParams = (values: any) => {
    const { sliderParam = {}, ...rest } = values ?? {};
    return {
      scene: 'nc_message',
      ...rest,
      sliderParam,
      ...sliderParam,
    };
  }
  // 获取短信验证码
  const setSms = async (values: any) => {
    const { mobile = '' } = fetchRef.current.forms;
    if (!mobile?.trim()?.length) {
      resetSlider();
      Toast('请输入手机号');
      return;
    }
    loadingRef.current.setSms = true;
    try {
      await API.ApiEmployeeSmsSend28735({
        mobile: mobile.trim(),
        ...values
      });
      loadingRef.current.setSms = false;
      setSmsCountdown(60);
      startCountdown(60);
    } catch (error) {
      loadingRef.current.setSms = false;
      resetSlider();

    }
  }
  // 短信倒计时
  const startCountdown = (countdown: number) => {
    timer.current = setTimeout(() => {
      const next = countdown - 1;
      setSmsCountdown(next);
      if (next > 0) {
        startCountdown(next);
      } else {
        resetSlider();
      }
    }, 1000)
  }
  // 登录
  const login = async () => {
    const { smsCode = '', mobile = '' } = formVal;
    if (loadingRef.current.login || checkFn(true)) {
      return;
    }
    loadingRef.current.login = true;
    try {
      const res = await API.ApiEmployeeSmsLogin28742({
        mobile: mobile.trim(),
        smsCode: smsCode.trim(),
      });
      loadingRef.current.login = false;
      sessionStorage.setItem('tmpToken',res?.data?.tmpToken || '')
      // cookie.save('tmpToken', res?.data?.tmpToken || '', { expires: new Date(moment().add(1, 'day').startOf('day').valueOf()) })
      close(true)
    } catch (error) {
      loadingRef.current.login = false;
   
    }

  }
  useEffect(() => {
    if (visible) {

    } else {
      clearTimeout(timer.current);
      setFormVal({});
      setSmsCountdown(0);
      resetSlider();
      fetchRef.current.forms  = {};
    }
    return () => {
      clearTimeout(timer.current);
    }
    // eslint-disable-next-line
  }, [visible])
  const sliderSuccess = (values: any) => {
    setSms(getSmsParams(values));
  }
  const getWith = () => {
    const width = document.documentElement.clientWidth * 0.746;
    return width > 300 ? width : 300;
  }
  return (
    <div className={['securityStaff-modal', visible ? '' : 'close'].join(' ')}>
      <div className="title-wrap">
        手机校验
        <CloseOutlined onClick={() => close()} />
      </div>
      <div className="form-wrap">
        <YInput title="手机号" value={formVal.mobile} maxLength={11} onChange={(val) => setForm('mobile', val)} />
        <div className="aliview"  >
          <AuthAliAwsc key={sliderKey} width={getWith()} awscId='smsSlider' success={sliderSuccess} />
        </div>
        <YInput
          title="短信验证码"
          value={formVal.smsCode}
          maxLength={6}
          render={(
            <div className={["sent-message",'gray'].join(' ')}>
              {smsCountdown ? `${smsCountdown}s后重新获取` : '获取短信验证码'}
            </div>
          )}
          onChange={(val) => setForm('smsCode', val)}
        />
        <div className="button" onClick={login}>确 认</div>
      </div>
      <div className="fixed-wrap"></div>
    </div>
  )
})

export default Modal;
